module.exports = __webpack_public_path__ + "img/5.8a7a2133.jpg";